module.exports = __webpack_public_path__ + "static/monitors-8b76a498b56d83cde3aab6f972ee66fd.png";